var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9081 2.37243L17.8558 12.5407L15.5417 17.1982L14.206 19.8863L14.1856 19.8799C14.1304 19.9803 14.0727 20.0791 14.0132 20.1764C13.3938 21.1936 12.5477 22.0544 11.5503 22.6854C10.3955 23.4126 9.03481 23.8332 7.57867 23.8332C5.05682 23.8332 2.82321 22.5729 1.44515 20.6345C0.535298 19.3547 0 17.7796 0 16.0776C0 16.0697 -3.02993e-07 16.0614 0.000304497 16.0535C0.00304906 15.0512 0.192462 14.0929 0.533773 13.2145C0.648154 12.9183 0.780225 12.6307 0.928766 12.3537C0.930596 12.35 0.932427 12.3464 0.934562 12.343L1.11452 12.0261L3.60343 7.64124H3.60373L6.75697 1.90576L9.32488 6.37604L9.09337 6.79513L8.74413 7.42681L8.22805 8.35039C8.22988 8.3507 8.23171 8.3507 8.23354 8.35101L5.16175 13.909L4.51512 15.0781C4.38976 15.4764 4.33882 15.9092 4.37512 16.3591C4.50017 17.9223 5.72358 19.1952 7.24895 19.3507C7.82085 19.409 8.36591 19.3138 8.84967 19.1003C9.49904 18.8133 10.0243 18.2938 10.3665 17.6603L10.5706 17.2824L12.1853 14.2924L12.9399 12.6688L15.2318 7.73579L17.7234 2.37243L22.9081 2.37243Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74411 7.42725L8.23352 8.35144C8.23169 8.35113 8.22986 8.35113 8.22803 8.35083L8.74411 7.42725Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11453 12.0264L0.93457 12.3433C0.991911 12.2359 1.052 12.1304 1.11453 12.0264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2317 7.73599L12.9398 12.669L9.32481 6.37624L6.7569 1.90596C7.9315 -0.197724 10.8996 -0.186437 12.0586 1.92639L15.2317 7.73599Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1144 24.0001H19.4489L15.5417 17.1986L17.8558 12.541L24.1144 24.0001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.934261 12.3433C0.932126 12.3466 0.930296 12.3503 0.928466 12.3539H0.928162L0.934261 12.3433Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1135 0.00146484L23.9714 0.28025H18.6669L18.7959 0.00146484H24.1135Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7816 0.652344L23.6395 0.931125H18.3655L18.4945 0.652344H23.7816Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4498 1.30273L23.3073 1.58152H18.0645L18.1935 1.30273H23.4498Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1176 1.95312L22.9755 2.23191H17.7634L17.8924 1.95312H23.1176Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1174 1.95312L22.9753 2.23191L17.7614 2.23587L17.7632 2.23191L17.8922 1.95312H23.1174Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4498 1.30273L23.3073 1.58152H18.0645L18.1935 1.30273H23.4498Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7816 0.652344L23.6395 0.931125H18.3655L18.4945 0.652344H23.7816Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1144 0L24.1135 0.00152353L23.9714 0.280308H18.6669L18.7959 0.00152353L18.7965 0L24.1144 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenCircleIcon);
export default __webpack_public_path__ + "static/media/cen-circle-icon.6b18843503556f319fbdc5fce4a2b72c.svg";
export { ForwardRef as ReactComponent };